import { BaseSanitizer } from './BaseSanitizer';
export class UsernameSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'USERNAME', 'usernames', enabled);
    }
    detectMatches(text) {
        const patterns = [
            '@[a-zA-Z0-9_]{3,20}\\b',
            '\\buser:[a-zA-Z0-9_-]+\\b',
            '\\busername:[a-zA-Z0-9_-]+\\b'
        ];
        const matches = [];
        for (const pattern of patterns) {
            const regex = new RegExp(pattern, 'g');
            let match;
            while ((match = regex.exec(text)) !== null) {
                matches.push({
                    originalText: match[0],
                    tag: '',
                    startIndex: match.index,
                    endIndex: match.index + match[0].length
                });
            }
        }
        return matches;
    }
}
